import { connect } from "react-redux";
import Item from "./components/Item";

const UserPoints = ({ packer_user_points, picker_user_points }) => {
  return (
    <>
      <div className="dashboard m-b-10">
        <header className="dashboard__header dashboard__header--edit">
          <h2 className="dashboard__title heading">Punkty paker</h2>
        </header>
        <ul className="dashboard__list">
          {packer_user_points.map((item) => (
            <Item key={item?.id} {...item} />
          ))}
        </ul>
      </div>
      <div className="dashboard m-b-10">
        <header className="dashboard__header dashboard__header--edit">
          <h2 className="dashboard__title heading">Punkty piker</h2>
        </header>
        <ul className="dashboard__list">
          {picker_user_points.map((item) => (
            <Item key={item?.id} {...item} />
          ))}
        </ul>
      </div>
    </>
  );
};

const mapStateToProps = ({
  gdn: {
    data: { gdn_lines, user_points: packer_user_points, gdn_pack },
  },
}) => {
  const all_picker_user_points = gdn_pack?.user_points || [];
  const product_ids = [...new Set(gdn_lines.map((item) => item?.product?.id))];
  const picker_user_points = all_picker_user_points.filter((item) =>
    product_ids.includes(item?.product_id),
  );
  return {
    packer_user_points,
    picker_user_points,
  };
};

export default connect(mapStateToProps, null)(UserPoints);
